// src/components/FD/ApplicationRegistration.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getTodayYYYYMMDD } from '../../utils/dateUtils';
import './ApplicationRegistration.css';

const ApplicationRegistration = () => {
  const [formData, setFormData] = useState({
    name: '',
    registration_no: '',
    phone_no: '',
    date: getTodayYYYYMMDD()
  });

  const [errors, setErrors] = useState({});
  const [registrationNo, setRegistrationNo] = useState(1);

  useEffect(() => {
    const fetchLatestRegistration = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/fd/latest-registration`);
        const latestRegNo = response.data.latestRegNo || 0;
        setRegistrationNo(latestRegNo + 1);
        setFormData(prev => ({
          ...prev,
          registration_no: `FD${String(latestRegNo + 1).padStart(3, '0')}`
        }));
      } catch {
        setRegistrationNo(1);
        setFormData(prev => ({ ...prev, registration_no: 'FD001' }));
      }
    };
    fetchLatestRegistration();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => {
        const newErr = { ...prev };
        delete newErr[name];
        return newErr;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.registration_no.trim()) {
      newErrors.registration_no = 'Registration number is required';
    }
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone_no.trim()) newErrors.phone_no = 'Phone number is required';
    if (!formData.date) newErrors.date = 'Date is required';
    
    // Validate phone number format (basic validation)
    if (formData.phone_no && !/^\d{10}$/.test(formData.phone_no.replace(/\D/g, ''))) {
      newErrors.phone_no = 'Please enter a valid 10-digit phone number';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      alert('Please fill all required fields correctly.');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/fd/new-application`, formData);
      if (response.data.success) {
        alert('Application created successfully!');
        setFormData({
          name: '',
          registration_no: `FD${String(registrationNo + 1).padStart(3, '0')}`,
          phone_no: '',
          date: getTodayYYYYMMDD()
        });
        setRegistrationNo(prev => prev + 1);
      }
    } catch (error) {
      console.error('Error creating application:', error);
      alert(error.response?.data?.error || 'Failed to create application.');
    }
  };

  return (
    <div className="fd-container">
      <form className="fd-form" onSubmit={handleSubmit}>
        <h1 className="fd-title">FD Application Registration</h1>

        <div className="fd-section">
          <div>
            <label>Registration No: <span className="fd-required">*</span></label>
            <input
              type="text"
              name="registration_no"
              value={formData.registration_no}
              onChange={handleChange}
              required
            />
            {errors.registration_no && <p className="fd-error">{errors.registration_no}</p>}
          </div>
          <div>
            <label>Date: <span className="fd-required">*</span></label>
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
            {errors.date && <p className="fd-error">{errors.date}</p>}
          </div>
        </div>

        <h3 className="fd-subtitle">Application Details</h3>
        <div className="fd-section">
          <div>
            <label>Name: <span className="fd-required">*</span></label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} />
            {errors.name && <p className="fd-error">{errors.name}</p>}
          </div>
          <div>
            <label>Phone No: <span className="fd-required">*</span></label>
            <input type="text" name="phone_no" value={formData.phone_no} onChange={handleChange} maxLength="10" />
            {errors.phone_no && <p className="fd-error">{errors.phone_no}</p>}
          </div>
        </div>

        <div className="fd-submit-container">
          <button type="submit" className="fd-submit">Submit Application</button>
        </div>
      </form>
    </div>
  );
};

export default ApplicationRegistration;

